/**
 * Thrown when a template control cannot be mapped onto a question type the assessments API
 * accepts - typically because the stored control has no `type` at all. Without it the key is
 * dropped by `JSON.stringify` and the API answers with an opaque mapping error, so this carries
 * enough identity to point at the offending control in the template.
 */
export class UnsupportedQuestionTypeError extends Error {

  constructor(
    readonly questionName: string,
    readonly questionLabel: string,
    readonly templateQuestionId: string,
    readonly rawType: string,
  ) {
    super(
      `Unsupported assessment question type. name: "${questionName}", label: "${questionLabel}", ` +
      `templateQuestionId: "${templateQuestionId}", type: "${rawType}"`
    );
    this.name = 'UnsupportedQuestionTypeError';
  }
}
